import { createSlice } from "@reduxjs/toolkit";
import { getBlogs } from "./blogApi";

// Slice for managing master doctor state
const blogSlice = createSlice({
  name: "blogs",
  initialState: {
    blogs: [],
    loading: false,
    error: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalSpecialties: 0,
  },
  extraReducers: (builder) => {
    // GET specialties FILTER WISE DATA
    builder.addCase(getBlogs.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getBlogs.fulfilled, (state, action) => {
      state.loading = false;
      state.blogs = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalBlogs = action.payload.meta.total;
    });
    builder.addCase(getBlogs.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export default blogSlice.reducer;
